<template>
    <div id="messagebackdetail"  v-loading.fullscreen.lock="loading">
        <div msg-back-filter></div>
        <div msg-back-head>
            <table>
                <tr>
                    <td mb-h-title>缺货反馈名称：</td>
                    <td>{{msgDetail.Title}}</td>
                </tr>
                <tr>
                    <td mb-h-title>发件人邮件：</td>
                    <td>{{msgDetail.Email}}</td>
                </tr>
                <tr>
                    <td mb-h-title>发件人姓名：</td>
                    <td>{{msgDetail.UserName}}</td>
                </tr>
            </table>
        </div>
        <div msg-back-filter></div>
        <div msg-back-desc>
            <div msg-back-desc-txt v-html="msgDetail.HtmlDetail"></div>
            <div msg-back-desc-bottom>
                <span>
                    <i class="fa fa-user-o" aria-hidden="true"></i> {{msgDetail.UserName}}</span>
                <span>
                    <i class="fa fa-clock-o" aria-hidden="true"></i> {{msgDetail.ReportTime}}</span>
            </div>
        </div>

        <div msg-back-filter></div>
        <div msg-back-commits>
            <div>答复历史</div>
            <div commits-list v-html="msgDetail.Commits==null?'无':msgDetail.Commits"></div>
        </div>

        <div msg-back-filter></div>
        <div msg-back-feedback>
            <div>答复</div>
            <div>
                <el-input type="textarea" placeholder="输入要回复的内容" size="mini" v-model="queryParams.Txt"></el-input>
            </div>
            <div>
                <el-button size="mini" @click="reply">回复</el-button>
            </div>
        </div>
    </div>
</template>

<script>
    import { getMessagebackDetail, SendReply } from "../../api/api";
    import store from "../../utils/storage";

    export default {
        name: "Login",
        data() {
            return {
                loading:false,
                msgDetail: {},
                queryParams: {
                    CallCardId: this.$route.params.callcardid,
                    Txt: '',
                    UserId: this.$route.params.uid,
                    MsgId: this.$route.params.msgid,
                }
            };
        },
        mounted() {
            this.getMessagebackDetail();
        },
        methods: {
            getMessagebackDetail() {
                this.loading = true;
                getMessagebackDetail(this.queryParams).then(res => {
                    this.loading = false;
                    if (res.data.Code != 1) return;
                    this.msgDetail = res.data.Data;
                    this.queryParams.Txt = this.msgDetail.Options;
                });
            },
            reply() {

                if(this.queryParams.Txt.lenght==0) 
                    return this.$message.error('回复信息不能为空');

                this.loading = true;
                this.queryParams.Txt = this.msgDetail.CurUserName +': '+ this.queryParams.Txt;
                var distUserId= this.msgDetail.UserId;
                SendReply(this.queryParams,distUserId).then(res => {
                    if (res.data.Code != 1) return;
                    this.getMessagebackDetail();
                });
            }
        }
    }
</script>


<style scoped>
    @import "../../assets/css/infoData/messagedetail.css";
</style>


// WEBPACK FOOTER //
// src/components/infoData/MessageBackDetail.vue